import { MultiSelectField, OptionType, SubmitButton, VStack } from '@medely/ui-kit';
import React from 'react';
import { useWatch } from '@medely/ui-kit/react-hook-form';

type RecommendedSpecialtiesFormProps = {
  options: OptionType[];
  isSpecialtiesLoading: boolean;
  showSpecialtySpeedbumExtension: boolean;
};

export const RecommendedSpecialtiesForm = ({
  options,
  isSpecialtiesLoading,
  showSpecialtySpeedbumExtension,
}: RecommendedSpecialtiesFormProps) => {
  const selectedSpecialties = useWatch({ name: 'add_specialty_ids' });

  const optionsLength = options.length;
  const selectedLength = selectedSpecialties ? selectedSpecialties.length : 0;

  const disableConfirmButton = optionsLength !== selectedLength && showSpecialtySpeedbumExtension;

  return (
    <>
      <VStack gap={2} my={2}>
        {!!options && (
          <MultiSelectField
            variant="list"
            options={options}
            label=""
            name="add_specialty_ids"
            testId="recommended-specialties-info-select"
          />
        )}
      </VStack>
      <SubmitButton
        fullWidth
        loading={isSpecialtiesLoading}
        disabled={isSpecialtiesLoading || disableConfirmButton}
        testId="recommended-specialties-info-confirm-button"
      >
        {showSpecialtySpeedbumExtension ? 'Confirm and book' : 'Confirm and continue'}
      </SubmitButton>
    </>
  );
};
